import React from 'react'

import Header from '../../common/components/Header'
import ClosureDetailsPager from './ClosureDetailsPager'
import ClosureDetailsHeader from './ClosureDetailsHeader'
import ClosureDetails from './ClosureDetails'

import styles from './ClosureDetails.module.css'

const ClosureDetailsPanel = () => {
  return (
    <div className={styles.panel}>
      <Header>Details</Header>
      <ClosureDetailsHeader />
      <ClosureDetails />
      <ClosureDetailsPager />
    </div>
  )
}
export default ClosureDetailsPanel
